<template>
  <div>
    <v-app-bar app :hide-on-scroll="false" elevate-on-scroll v-resize="checkMobile" :class="[isIos ? 'ios-appbar' : '', isAndroid ? 'android-appbar' : '']">
      <v-app-bar-nav-icon @click="reverseDrawer">
        <v-icon v-if="show_drawer">mdi-menu-open</v-icon>
        <v-icon v-else>mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn v-if="user_role == 'partner'" text to="/investor_analytics" class="d-none d-lg-flex">
        <span>{{ $t("custom.analitics") }}</span>
      </v-btn>
      <v-btn text to="/bookings/list" @click="$store.commit('setNewBooking', false)" class="d-none d-lg-flex">
        <v-badge v-if="new_booking" dot color="red">
          <span class="">{{ $t("custom.bookings") }}</span>
        </v-badge>
        <span v-else class="">{{ $t("custom.bookings") }}</span>
      </v-btn>
      <!-- FT-081 rework: обычная ссылка — клик = навигация, триал НЕ стартует отсюда.
           Триал-доступный админ попадает на страницу CRM с intro и явной кнопкой «Подключить». -->
      <v-btn text to="/crm/leads" class="d-none d-lg-flex"
             v-if="(isCrmEnabled && hasCrmAccess) || (crmTrialAvailable && isCrmAdmin)">
        <span>{{ $t("crm.menu.leads") }}</span>
      </v-btn>
      <v-menu offset-y open-on-hover v-if="isInternal">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="d-none d-lg-flex" v-bind="attrs" v-on="on">
            {{ $t("custom.clients") }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/clients">
            <v-list-item-title>{{ $t("custom.clients") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/debts">
            <v-list-item-title>{{ $t("custom.debts") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/fines" v-if="menuRouteVisible('/fines')">
            <v-list-item-title>{{ $t("custom.fines") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/invoices">
            <v-list-item-title>{{ $t("custom.invoices") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y open-on-hover v-if="!isAgent">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="d-none d-lg-flex" v-bind="attrs" v-on="on">
            {{ $t("custom.calendar") }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/calendars/timeline">
            <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/calendars/gantt">
            <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text to="/counts" class="d-none d-lg-flex" v-if="!isPartner">
        <span class="">{{ $t("custom.counts") }}</span>
      </v-btn>
      <v-btn v-if="!isAgent" text to="/vehicles/list"
        class="d-none d-lg-flex">
        <span v-if="rental_object == 'cars'">{{ $t("custom.cars") }}</span>
        <span v-else>{{ menu_object_name() }}</span>
      </v-btn>
      <v-menu v-if="!isAgent" offset-y open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text class="d-none d-lg-flex" v-bind="attrs" v-on="on">
            {{ $t("custom.service") }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/service_tech">
            <v-list-item-title>{{ $t("custom.tech_service") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/service_insurance" v-if="menuRouteVisible('/service_insurance')">
            <v-list-item-title>{{ $t("maintenance.insurances_and_taxes") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/service_payments">
            <v-list-item-title>{{ $t("maintenance.payments") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- Исходно тут был перечислен ровно STAFF_ROLES четырьмя литералами;
           моя массовая замена разбила его на пару + `isManager || isUser`,
           а геттера isUser нет — роль user молча теряла кнопку (undefined в
           позиции ||). Это и есть isStaff. -->
      <v-btn v-if="isStaff" text to="/tasks" class="d-none d-lg-flex mr-2">
        {{ $t("tasks.menu") }}
      </v-btn>
      <v-menu v-if="isAdminPlus ||
        user_role == 'guest'
      " offset-y open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="d-none d-lg-flex">
            <span class="">
              {{ $t("header.company") }}
            </span>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item to="/company_counts">
            <v-list-item-title>{{
              $t("header.company_counts")
              }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/users">
            <v-list-item-title>{{ $t("custom.employers") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/analitics">
            <v-list-item-title>
              {{ $t("custom.analitics") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/company_profile">
            <v-list-item-title>{{
              $t("header.company_settings")
              }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isCrmAdmin" to="/website_chats">
            <v-list-item-title>{{ $t('crm.website_chat.title') }}<BetaChip /></v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isAdminPlus" to="/booking_widgets">
            <v-list-item-title>{{ $t("booking_widgets.title") }}<BetaChip /></v-list-item-title>
          </v-list-item>
          <v-list-item to="/contractors">
            <v-list-item-title>
              {{ $t("custom.contractors") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/history">
            <v-list-item-title>
              {{ $t("home.events") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/schedule_calendar" v-if="isInternal">
            <v-list-item-title>{{ $t("custom.schedule") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="($store.getters.getMainCompany && $store.getters.getCompany.company && $store.getters.getCompany.company.in_booking)
            && isInternal && menuRouteVisible('/agregator/settings')
          " to="/agregator/settings">
            <v-list-item-title>{{ $t("agregator.agregator") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/investors" v-if="isAdminPlus ||
            user_role == 'guest'
          ">
            <v-list-item-title>{{ $t("header.partners") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/branches" v-if="user_role == 'superadmin'">
            <v-list-item-title>{{ $t("header.branches") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tariffs" v-if="isAdminPlus ||
            isManager || isGuest
          ">
            <v-list-item-title>{{ $t("header.tariffs") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/doc_template" v-if="($store.getters.getMainCompany &&
            $store.getters.getCompany.company &&
            ($store.getters.getCompany.company.new_templates ||
              $store.getters.getCompany.company.pdf_templates) &&
            (isAdminPlus ||
              isManager || isGuest))
          ">
            <v-list-item-title>{{ $t("header.pdf_templates") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/store" v-if="isInternal">
            <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goToMap()" v-if="isInternal && traccarMapAvailable">
            <v-list-item-title>{{ $t("header.mayaks") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/agents">
            <v-list-item-title>
              {{ $t("agents.agents") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/locations">
            <v-list-item-title>
              {{ $t("locations.locations") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider vertical class="d-none d-lg-flex mx-1"></v-divider>
      <v-btn v-if="isInternal && !isInvoiceClient" text to="/transactions"
        :class="isMobile ? 'mr-2' : 'mr-0'">
        <span :class="$store.getters.getMainCompany &&
          $store.getters.getMainCompany.balance < 0
          ? 'red--text'
          : ''
          ">
          {{
            $store.getters.getMainCompany
              ? Math.round($store.getters.getMainCompany.balance)
              : 0
          }}
          <span>{{
            $store.getters.getMainCompany &&
              $store.getters.getMainCompany.currency == "RUB"
              ? "₽"
              : "€"
          }}</span>
        </span>
      </v-btn>

      <!-- WhatsApp -->
      <v-btn
        v-if="!isMobile && !isNative && company && company.whatsapp && isStaff"
        to="/whatsapp_chat" icon>
        <v-icon class="">
          mdi-whatsapp
        </v-icon>
      </v-btn>
      <v-btn v-if="!isMobile && !isNative" to="/search_free" icon>
        <v-icon class="">
          mdi-car-search-outline
        </v-icon>
      </v-btn>
      <!-- Notifications bell -->
      <NotificationBell />
      <!-- Teletype -->
      <v-btn
        v-if="teletypeAvailable"
        to="/teletype" icon @click="resetTeletypeMessagesCount" class="d-none d-lg-flex">
        <v-badge :content="$store.getters.getTeletypeMessagesCount" :value="$store.getters.getTeletypeMessagesCount > 0"
          color="green" overlap>
          <v-icon> mdi-chat </v-icon>
        </v-badge>
      </v-btn>
      <!-- Branches -->
      <v-menu v-if="user_role == 'superadmin' ||
        (currentUser() && currentUser().can_change_branch)
      " left bottom offset-y offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="loadBranches" v-bind="attrs" v-on="on" icon class="mr-1">
            <v-progress-circular v-if="isLoading" indeterminate color="primary"></v-progress-circular>
            <v-icon v-else> mdi-city-variant-outline </v-icon>
          </v-btn>
        </template>
        <v-list nav :dense="isMobile">
          <v-list-item v-for="branch in branches" :key="branch.id" @click="changeBranch(branch.id)"
            :active="branch.id == company_id">
            <v-list-item-title><v-icon v-if="branch.id == company_id" class="mr-1" color="primary">
                mdi-arrow-right-bold-circle-outline </v-icon>{{ branch.name }}, {{ branch.city }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <page-search ref="pageSearch"></page-search>
      <v-menu left bottom offset-y offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mr-1 d-none d-lg-flex">
            <v-badge :content="$store.getters.getHasNewTicket" :value="$store.getters.getHasNewTicket" dot
              color="warning">
              <v-icon size="28"> mdi-help-circle-outline </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item to="/support/tickets">
            <v-list-item-action>
              <v-icon>mdi-ticket-account</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item>
          <v-list-item :href="docsLink('/')" target="_blank">
            <v-list-item-action>
              <v-icon>mdi-help-circle</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- vertical divider -->
      <v-divider vertical class="d-none d-lg-flex mr-3"></v-divider>
      <v-menu left bottom offset-y offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon :ripple="false" class="pa-0 header-avatar-btn" v-bind="attrs" v-on="on" id="registration-step-1">
            <v-badge
              :content="$store.getters.getHasNewTicket || $store.getters.getTeletypeMessagesCount"
              :value="$store.getters.getHasNewTicket || $store.getters.getTeletypeMessagesCount" dot
              color="warning">
              <div :class="isMobile ? 'd-flex flex-column align-center' : 'd-flex flex-column align-center mt-2'">
                <UserAvatar
                  size="35"
                  color="blue"
                  :class="isMobile ? 'my-0' : 'my-1'"
                  :avatar-url="avatar_url"
                  :name="currentUser() && currentUser().name ? currentUser().name : (currentUser() && currentUser().email ? currentUser().email : '')"
                />
                <span class="text-caption m-0 p-0" v-if="!isMobile">
                  <span class="user-name m-0 p-0">{{ truncateUsername(currentUser() && currentUser().name ? currentUser().name :
                    (currentUser() && currentUser().email ? currentUser().email : ''))
                    }}</span>
                </span>
              </div>
            </v-badge>
          </v-btn>
        </template>
        <v-list :dense="isMobile || isNative">
          <v-list-item to="/profile">
            <v-list-item-title>{{ $t("header.profile") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/salary" v-if="isInternal">
            <v-list-item-title>{{ $t("custom.salary") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/transactions" v-if="isInternal && !isNative && !isInvoiceClient">
            <v-list-item-title>{{ $t("header.balance") }}:
              {{
                $store.getters.getMainCompany
                  ? Math.round($store.getters.getMainCompany.balance)
                  : 0
              }}<span>{{
                $store.getters.getMainCompany &&
                  $store.getters.getMainCompany.currency == "RUB"
                  ? "₽"
                  : "€"
              }}</span></v-list-item-title>
          </v-list-item>
          <v-list-item to="/transactions" v-else-if="isInternal && !isNative && isInvoiceClient">
            <v-list-item-title>{{ $t("tariffs.billing") }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/support/tickets"
            v-if="isStaff">
            <v-badge :content="$store.getters.getHasNewTicket" :value="$store.getters.getHasNewTicket" dot
              color="warning">
              <v-list-item-title>
                {{ $t("support.tickets") }}
              </v-list-item-title>
            </v-badge>
          </v-list-item>
          <v-list-item to="/teletype"
            v-if="teletypeAvailable"
            class="mb-2 d-flex align-center">
            <v-badge :content="$store.getters.getTeletypeMessagesCount"
              :value="$store.getters.getTeletypeMessagesCount > 0" dot color="warning">
              <v-list-item-title>
                {{ $t("teletype.teletype_messages") }}
              </v-list-item-title>
            </v-badge>
          </v-list-item>
          <v-list-item :href="docsLink('/')" target="_blank">
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item>
          <!-- FT-191: на общем компьютере вместо выхода — блокировка и смена сотрудника -->
          <template v-if="$store.getters['deviceLock/deviceMode']">
            <v-list-item data-test="device-lock-now" @click="$store.dispatch('deviceLock/lock')">
              <v-list-item-title>{{ $t("device_lock.lock_now") }}</v-list-item-title>
            </v-list-item>
            <v-list-item data-test="device-switch-user" @click="$store.dispatch('deviceLock/lock')">
              <v-list-item-title>{{ $t("device_lock.switch_user") }}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item v-else @click="signOut()">
            <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-dialog :retain-focus="false" @click:outside="(showMessageDialog = false), (message = null)"
        v-model="showMessageDialog" max-width="500px">
        <v-card v-if="message">
          <v-card-title>
            <h2>{{ message.title }}</h2>
            <v-spacer></v-spacer>
            <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
              @click="(showMessageDialog = false), (message = null)">
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="mt-2">
            {{ message.sender }}
          </v-card-subtitle>
          <v-card-text>
            <div style="white-space: pre-line">{{ message.text }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <audio id="message-audio" src="/message.mp3" preload="auto" hidden="true" ref="message"></audio>
      <audio id="booking-audio" src="/discord.mp3" preload="auto" hidden="true" ref="booking"></audio>
    </v-app-bar>
    <v-dialog v-model="showAudioNotAllowedNotification" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          {{ $t("teletype.audio_not_allowed") }}
        </v-card-title>
        <v-card-actions>
          <v-btn @click="enableSound" block color="primary">{{ $t("teletype.enable_sound") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <drawer></drawer>
  </div>
</template>

<script>
import { secretSet } from "@/utils/integrationSecrets"; // FT-195
import { setMomentLocale } from "@/utils/localeInfra";
import { routeVisible } from "@/utils/rentalObjectFeatures";
import { markIntentionalLogout } from "@/utils/sessionExpiry";
import { forgetPushDevice, registerPushDevice } from "@/utils/pushDevice";
import UserAvatar from "@/components/shared/UserAvatar.vue";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import { isVirtualDeviceOrFalse } from "@/utils/nativeDevice";
import { App as CapacitorApp } from '@capacitor/app';
import { openAppPath, pushTapPath } from '@/router/deepLink';
import { PushNotifications } from "@capacitor/push-notifications";
import { FCM } from "@capacitor-community/fcm";
import { Badge } from "@capawesome/capacitor-badge";
import { StatusBar } from "@capacitor/status-bar";
import drawer from "./Drawer";
import PageSearch from './PageSearch.vue'
import purchaseService from '@/services/purchaseService';
import NotificationBell from "@/components/notifications/NotificationBell.vue";
import CableSubscriber from "@/mixins/CableSubscriber";

export default {
  name: "AppHeader",
  mixins: [CableSubscriber],
  data() {
    return {
      items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.company_counts"),
              icon: "mdi-cash-lock",
              to: "/company_counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
        {
          icon: "mdi-domain",
          title: this.$t("header.company"),
          active: false,
          items: [
            {
              title: this.$t("custom.analitics"),
              icon: "mdi-chart-areaspline",
              to: "/analitics",
            },
            {
              title: this.$t("custom.employers"),
              icon: "mdi-account-hard-hat",
              to: "/admin/users",
            },
            {
              title: this.$t("custom.schedule"),
              icon: "mdi-calendar-multiselect",
              to: "/schedule_calendar",
            },
            {
              title: this.$t("custom.salary"),
              icon: "mdi-account-cash-outline",
              to: "/salary",
            },
            {
              title: this.$t("header.partners"),
              icon: "mdi-handshake-outline",
              to: "/investors",
            },
            {
              title: this.$t("header.branches"),
              icon: "mdi-source-branch",
              to: "/branches",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
            {
              title: this.$t("home.events"),
              icon: "mdi-math-log",
              to: "/history",
            },
            {
              title: this.$t("header.company_settings"),
              icon: "mdi-cog-box",
              to: "/company_profile",
            },
            {
              title: this.$t("agents.agents"),
              icon: "mdi-face-agent",
              to: "/agents",
            },
          ],
        },
      ],
      selected_items: [],
      worker_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      manager_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
            {
              title: this.$t("home.events"),
              icon: "mdi-math-log",
              to: "/history",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      partners_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      agents_items: [
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
          ],
        },
      ],
      branches: [],
      messages_size: 0,
      messages: [],
      message: null,
      closeOnContentClick: false,
      user: [],
      todos: [],
      showMessageDialog: false,
      servicesWarning: false,
      check_server: null,
      isLoading: false,
      isMobile: false,
      error: "",
      notificationAudio: null,
      showAudioNotAllowedNotification: false
    };
  },
  async mounted() {
    let self = this;
    this.pushListenerHandles = [];
    if (this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.id) {
      // company уже загружена (есть id) — поднимаем подписки. Дублирующий вызов от watcher
      // на company.id безопасен (initializeSubscriptions идемпотентен по subscriptionsInitialized).
      // Гейт по `.id`, а НЕ по truthy `getCompany.company`: начальный state.company — непустой {},
      // поэтому старый `if (getCompany.company)` на гоночном маунте уводил сюда, init падал в
      // guard «company not loaded», а ветка GET /company (else) пропускалась → realtime не вставал.
      this.$store.dispatch('websocketSubscriptions/initializeSubscriptions', {
        userRole: this.user_role
      });
      // FT-066: AppHeader-owned channels (component context). Idempotent via held refs.
      this.subscribeAppHeaderChannels();

      console.info(
        "Company " +
        this.$store.getters.getCompany.company.id +
        " MainCompany " +
        (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.id)
      );
    } else {
      // не удалять, нужно
      this.axios
        .get(`/api/v1/company`, {
          headers: {
            // localStorage — source of truth после refresh: vuex-persist восстанавливает
            // state, но axios.defaults/getAuthToken могут быть пусты → иначе 401 → вышибает.
            // Authorization: localStorage.getItem("auth_token"),
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
          // this.$router.push({ path: `/dashboard` }).catch(err => {})
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.company_data"));
          console.log(error);
        });
    }
    // iOS-симулятор — по Device.isVirtual, а не по слову Simulator в UA: в UA
    // его нет, и гейт никогда не срабатывал (ревью PR #433, utils/nativeDevice.js).
    // Сбой плагина = реальное устройство. Гейт по-прежнему только для iOS.
    const isSimulator =
      Capacitor.getPlatform().toLowerCase() === "ios" && (await isVirtualDeviceOrFalse("AppHeader push"));
    // Пока ждали ответ платформы, компонент могли снять (logout → /signin):
    // регистрировать пуши и вешать листенеры на разрушенный инстанс нельзя.
    if (this.disposed) return;

    if (isSimulator) {
      console.warn('Push notifications are not supported on iOS Simulator. Skipping initialization.');
    }
    
    if (
      !isSimulator &&
      ((this.isPushNotificationsAvailable &&
        Capacitor.isNativePlatform() &&
        Capacitor.getPlatform().toLowerCase() == "ios") ||
      Capacitor.getPlatform().toLowerCase() == "android")
    ) {
      // Хендлы листенеров держим на инстансе: снимаем ровно свои в beforeDestroy
      // (removeAllListeners глобален и глушил бы пуши на каждом размонтировании
      // шапки — /signin, ClientPage, /404). Листенер, доехавший после destroy,
      // снимается сразу.
      const addPushListener = async (event, handler) => {
        const handle = await PushNotifications.addListener(event, handler);
        if (self.disposed) {
          handle.remove();
        } else {
          self.pushListenerHandles.push(handle);
        }
      };
      const pushRegistration = async () => {
        try {
          await addPushListener("registration", (token) => {
            FCM.getToken()
              .then((r) => {
                self.fcm_token = r.token;
                if (r.token) {
                  registerPushDevice(self, r.token, Capacitor.getPlatform().toLowerCase()).catch((error) => {
                    self.setError(error, self.$t("errors.error"));
                  });
                }
              })
              .catch((error) => {
                self.setError(error, self.$t("errors.error"));
              });
          });
        } catch (error) {
          if (error.code !== 'UNIMPLEMENTED') {
            console.error("PushNotifications registration listener error:", error);
          }
        }
      };

      const pushRegistrationError = async () => {
        try {
          await addPushListener("registrationError", (error) => {
            // self.setError(JSON.stringify(error), "Error on registration");
            console.error("PushNotifications registrationError listener error:", error.error);
          });
        } catch (error) {
          if (error.code !== 'UNIMPLEMENTED') {
            console.error("PushNotifications registrationError listener error:", error);
          }
        }
      };
      const pushNotificationReceived = async () => {
        try {
          await addPushListener(
            "pushNotificationReceived",
            (notification) => {
            console.log("Push received: ", notification);
            const increase = async () => {
              try {
                await Badge.increase();
              } catch (error) {
                if (error.code !== 'UNIMPLEMENTED') {
                  console.error('Badge increase error:', error);
                }
              }
            };
            increase();
            }
          );
        } catch (error) {
          if (error.code !== 'UNIMPLEMENTED') {
            console.error("PushNotifications pushNotificationReceived listener error:", error);
          }
        }
      };

      const pushNotificationActionPerformed = async () => {
        try {
          await addPushListener(
            "pushNotificationActionPerformed",
            (notification) => {
            console.log("Push action performed: ", notification);
            // Тап по пушу открывает карточку: бэкенд кладёт относительный
            // путь в data.url (новая бронь, отмена, ответственный, ТО, тикет).
            const tapPath = pushTapPath(notification);
            if (tapPath) openAppPath(this.$router, tapPath);
            const clear = async () => {
              try {
                await Badge.clear();
              } catch (error) {
                if (error.code !== 'UNIMPLEMENTED') {
                  console.error('Badge clear error:', error);
                }
              }
            };
            clear();
            }
          );
        } catch (error) {
          if (error.code !== 'UNIMPLEMENTED') {
            console.error("PushNotifications pushNotificationActionPerformed listener error:", error);
          }
        }
      };

      PushNotifications.requestPermissions().then((result) => {
        // Системный алерт разрешений мог висеть долго — за это время шапку могли
        // снять (logout); листенеры на разрушенный инстанс не вешаем.
        if (self.disposed) return;
        if (result.receive === "granted") {
          // self.push_granted = true;
          pushRegistration();
          pushRegistrationError();
          pushNotificationReceived();
          pushNotificationActionPerformed();
          
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register().catch((error) => {
            if (error.code !== 'UNIMPLEMENTED') {
              console.error("PushNotifications register error:", error);
            }
          });
        } else {
          // Show some error
        }
        console.log("Push notifications permissions: ", result);
      }).catch((error) => {
        if (error.code !== 'UNIMPLEMENTED') {
          console.error("PushNotifications requestPermissions error:", error);
        }
      });
    }

    // FT-066: TeletypeChannel subscription (gated by teletype_api_key + role) is created in
    // subscribeAppHeaderChannels() above (sole owner — boot module no longer subscribes it).
  },
  beforeCreate() {
    // if (!(process.env.NODE_ENV === "development") || !this.isNative) {
    //   this.$OneSignal.showSlidedownPrompt();
    // }
  },
  beforeDestroy() {
    // Async-продолжения mounted/created (после await Device.getInfo) сверяются с
    // этим флагом и не трогают плагины на разрушенном инстансе.
    this.disposed = true;
    // Свои листенеры PushNotifications снимаем по хендлам (см. addPushListener в
    // mounted); без снятия они копились при каждом ре-маунте и держали старый инстанс.
    (this.pushListenerHandles || []).forEach((handle) => {
      Promise.resolve(handle.remove()).catch((error) => {
        console.error("PushNotifications listener remove error:", error);
      });
    });
    this.pushListenerHandles = [];
    clearTimeout(this.crispSetupTimer);
    // FT-066: собственные каналы AppHeader (Appearance/NewBooking/Teletype, held-refs)
    // авто-отписываются mixin'ом CableSubscriber (его beforeDestroy выполняется рядом).
    // Boot-каналы (HeaderUser/Company/MainCompany) ведёт Vuex store и снимает на
    // logout / смене филиала (unsubscribeFromChannels), а не при destroy компонента.
    console.log("AppHeader: beforeDestroy — own channels auto-unsubscribed (CableSubscriber mixin); boot channels via store");
  },
  created() {
    let self = this;
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.getUserSettings &&
      this.$store.getters.getUserSettings.dark_theme
    ) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    // if (
    //   this.$store.getters.getCompany.company &&
    //   this.$store.getters.getCurrentUser.email &&
    //   this.isNative &&
    //   $crisp.is("website:available")
    // ) {
    //   const hideStatusBar = async () => {
    //     await StatusBar.hide();
    //   };
    //   $crisp.push([
    //     "on",
    //     "chat:opened",
    //     () => {
    //       hideStatusBar();
    //     },
    //   ]);

    //   // $crisp.do("chat:hide");
    //   // $crisp.push(["do", "chat:hide", [true]]);
    // }
    console.log("typeof $crisp !== 'undefined'", typeof $crisp !== "undefined");
    // Добавляю в чат данные пользователя (таймер снимается в beforeDestroy)
    this.crispSetupTimer = setTimeout(async () => {
      // Hide Crisp chat for restricted roles
      const restrictedRoles = ['partner', 'agent', 'guest'];
      if (restrictedRoles.includes(this.user_role) && typeof $crisp !== "undefined" && $crisp && $crisp.push) {
        $crisp.push(["do", "chat:hide"]);
        return;
      }
      // Crisp-пузырь скрыт глобально (main.js, после Crisp.configure) —
      // чат открывается только из меню «Поддержка» в дровере.
      // iOS-симулятор — по Device.isVirtual (см. utils/nativeDevice.js), не по UA.
      const isSimulatorCrisp =
        Capacitor.getPlatform().toLowerCase() === "ios" && (await isVirtualDeviceOrFalse("AppHeader crisp"));
      if (this.disposed) return;

      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCurrentUser.email &&
        this.isNative &&
        !isSimulatorCrisp &&
        $crisp && $crisp.push && typeof $crisp.push === 'function' && $crisp.on && typeof $crisp.on === 'function' &&
        this.checkCrispSiteAvailable()
      ) {
        // set CRISP_TOKEN_ID
        $crisp.push(["safe", true]);
        const hideStatusBar = async () => {
          try {
            await StatusBar.hide();
          } catch (error) {
            // StatusBar.hide() is not supported on simulator
            if (error.code !== 'UNIMPLEMENTED') {
              console.error('StatusBar hide error:', error);
            }
          }
        };
        const showStatusBar = async () => {
          try {
            await StatusBar.show();
          } catch (error) {
            // StatusBar.show() is not supported on simulator
            if (error.code !== 'UNIMPLEMENTED') {
              console.error('StatusBar show error:', error);
            }
          }
        };
        $crisp.on("chat:opened", () => {
          console.log("chat:opened");
          hideStatusBar();
        });
        $crisp.on("chat:closed", () => {
          console.log("chat:closed");
          showStatusBar();
          // Натив: пузырь остаётся скрытым, чат открывается из меню «Поддержка».
          $crisp.push(["do", "chat:hide"]);
        });
      }
      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCurrentUser.email &&
        typeof $crisp !== "undefined" && $crisp &&
        this.checkCrispSiteAvailable()
      ) {
        $crisp.push([
          "set",
          "user:email",
          [this.$store.getters.getCurrentUser.email],
        ]);
      }
      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.name &&
        typeof $crisp !== "undefined" && $crisp &&
        this.checkCrispSiteAvailable()
      ) {
        $crisp.push(["safe", true]);
        $crisp.push([
          "set",
          "user:company",
          [this.$store.getters.getCompany.company.name],
        ]);
      }
      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCurrentUser.phone &&
        typeof $crisp !== "undefined" && $crisp &&
        this.checkCrispSiteAvailable()
      ) {
        $crisp.push(["safe", true]);
        $crisp.push([
          "set",
          "user:phone",
          [this.$store.getters.getCurrentUser.phone],
        ]);
      }
      if (
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCurrentUser.name &&
        typeof $crisp !== "undefined" && $crisp &&
        this.checkCrispSiteAvailable()
      ) {
        $crisp.push(["safe", true]);
        $crisp.push([
          "set",
          "user:nickname",
          [
            this.$store.getters.getCurrentUser.name +
            " " +
            this.$store.getters.getCompany.company.name +
            " " +
            this.$store.getters.getCurrentUser.role +
            " " +
            this.$store.getters.getMainCompany.payer_state,
          ],
        ]);
      }
      // if (
      //   this.$store.getters.getCompany.company &&
      //   this.$store.getters.getCurrentUser.email &&
      //   this.isNative
      // ) {
      //   $crisp.do("chat:hide");
      //   // $crisp.push(["do", "chat:hide", [true]]);
      // }
    }, 3000);
    if (this.isNative) {
      // appUrlOpen (universal / app links) обрабатывается глобально в main.js
      // через src/router/deepLink.js. Возврат из Stripe Checkout (FT-071) отдельной
      // ветки здесь не имеет: ссылка /app-return?stripe_autopay=success редиректом
      // роутера приходит на /transactions с тем же query, а его один раз обрабатывает
      // TopupDialog.handleStripeAutopayReturn (refresh main_company + тост).
      CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        console.log('App state changed. Is active?', isActive);
        if (isActive) {
          console.log('App is active');
        } else {
          console.log('App is inactive');
        }
      });
    }
  },
  computed: {
    // «Маяки» — карта Traccar, только на десктопе в браузере.
    traccarMapAvailable() {
      return !!(this.main_company && this.main_company.beacons_on && !this.isMobile && !this.isNative);
    },
    // Teletype подключён — по признаку «задан» (значение ключа фронт не получает).
    teletypeAvailable() {
      const company = this.company;
      return !!(
        company &&
        company.country == "Russia" &&
        [2, 9859, 10955].some((id) => id == company.id) &&
        secretSet(company, "teletype_api_key") &&
        this.isStaff
      );
    },
    appVersion() {
      return this.$store.getters.appVersion;
    },
    isCrmEnabled() {
      return this.$store.getters["crm/isCrmEnabled"];
    },
    hasCrmAccess() {
      return this.$store.getters["crm/hasCrmAccess"];
    },
    crmTrialAvailable() {
      return this.$store.getters["crm/crmTrialAvailable"];
    },
    isCrmAdmin() {
      return this.$store.getters["crm/isCrmAdmin"];
    },
    isInvoiceClient() {
      return this.$store.getters.getMainCompany?.payment_provider_preference === 'paddle' &&
             this.$store.getters.getMainCompany?.plan?.billing_collection_method === 'invoice';
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    new_booking() {
      return this.$store.getters.getNewBookingState;
    },
    current_user() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser;
      } else {
        return null;
      }
    },
    avatar_url() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.avatar_url;
      } else {
        return null;
      }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    isPushNotificationsAvailable() {
      return Capacitor.isPluginAvailable("PushNotifications");
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    isAndroid() {
      return Capacitor.getPlatform().toLowerCase() == "android" ? true : false;
    },
    company_id() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company
      ) {
        return this.$store.getters.getCompany.company.id;
      } else {
        return null;
      }
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
    show_drawer: {
      get: function () {
        return this.$store.getters.getDrawer
      },
      set: function (newValue) {
        this.$store.commit("setDrawer", newValue)
      }
    },
  },
  methods: {
    // FT-066: AppHeader owns 3 channels whose received() needs component context
    // (perform / sound / router): AppearanceChannel, NewBookingChannel, TeletypeChannel.
    // Subscriptions are held on the instance (this.<x>Sub) and auto-unsubscribed by the
    // CableSubscriber mixin in beforeDestroy. Idempotent: each guarded by `if (this.<x>Sub) return`.
    subscribeAppHeaderChannels() {
      const companyWrapper = this.$store.getters.getCompany;
      const company = companyWrapper && companyWrapper.company;
      if (!company || !company.id) return;
      const userId = this.$store.getters.currentUserId;

      // AppearanceChannel — online-status; received + perform (appearance_user).
      if (!this.appearanceSub) {
        this.appearanceSub = this.$cableSubscribe(
          { channel: "AppearanceChannel", room: company.id, user_id: userId },
          {
            connected: () => this.appearance_user(),
            disconnected: () => console.log("disconnected"),
            received: (data) => this.onAppearanceReceived(data),
          },
        );
      }

      // NewBookingChannel — new-booking badge + sound (non-partner/guest only).
      // Агенту подписка нужна: он оформляет брони и должен видеть чужие
      // изменения. Было «не partner и не guest» — то есть staff + agent;
      // при переводе на isStaff агент молча терял realtime.
      if (!this.newBookingSub && (this.isStaff || this.isAgent)) {
        this.newBookingSub = this.$cableSubscribe(
          { channel: "NewBookingChannel", room: company.id },
          { received: (data) => this.onNewBookingReceived(data) },
        );
      }

      // TeletypeChannel — teletype messages + sound. Sole owner (boot module no longer subscribes).
      // Gated by teletype_api_key + role (partner/agent/guest excluded), as the old @1117 block was.
      if (
        !this.teletypeSub &&
        this.$store.getters.isLoggedIn &&
        secretSet(company, "teletype_api_key") &&
        this.isStaff
      ) {
        this.teletypeSub = this.$cableSubscribe(
          { channel: "TeletypeChannel", room: company.id },
          { received: (data) => this.onTeletypeReceived(data) },
        );
      }
    },

    // AppearanceChannel received (moved from the old channels option — this-rebinding via arrow above).
    onAppearanceReceived(data) {
      this.$store.commit("setLoginUsers", data);
      if (data && data.balance) {
        const main_company = this.$store.getters.getMainCompany;
        if (main_company && main_company.balance) {
          this.$store.commit("setMainCompany", { ...main_company, balance: data.balance });
        }
      }

      // Выходим в соседней вкладке
      if (
        this.$store.getters.currentUserId &&
        this.$store.getters.currentUserId == data.id &&
        data.login == false &&
        data.logout == true
      ) {
        this.signOut();
      }
    },

    // NewBookingChannel received (moved from the old channels option; uses isNative/$router/audio).
    onNewBookingReceived() {
      this.$store.commit("setNewBooking", true);
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.new_booking_sound &&
        this.$store.getters.getUserSettings &&
        this.$store.getters.getUserSettings.new_booking_sound &&
        !this.isNative
      ) {
        try {
          const audio = document.getElementById('booking-audio');
          if (audio && this.$router.currentRoute.path != "/teletype") {
            this.promiseBasedPlay(audio).catch(error => {
              console.log("Failed to play sound:", error);
            });
          }
        } catch (e) {
          console.log("Error playing sound:", e);
        }
      }
    },

    // TeletypeChannel received (moved from the old channels option; uses isNative/$router/audio).
    onTeletypeReceived(data) {
      console.log("Received data in header:", data);
      if (!data || !data.name || !data.payload) return;

      try {
        const payloadData = JSON.parse(data.payload);

        // Обработка новых сообщений
        if (data.name === "new message" && payloadData.message) {
          this.$store.commit("addTeletypeNewMessage", payloadData);
          if (data.name === "success send" && payloadData.messageId) {
            console.log("Message sent successfully:", payloadData.messageId);
          }
          else if (data.name === "message status change" && payloadData.messageId) {
            console.log("Message status changed:", payloadData.messageId, payloadData.messageStatus);
          }

          // Пытаемся воспроизвести звук, но предусматриваем ошибку
          if (
            this.$store.getters.getCompany &&
            this.$store.getters.getCompany.company &&
            this.$store.getters.getCompany.company.new_message_sound &&
            this.$store.getters.getUserSettings &&
            this.$store.getters.getUserSettings.new_message_sound &&
            !this.isNative
          ) {
            try {
              const audio = document.getElementById('message-audio');
              if (audio && this.$router.currentRoute.path != "/teletype") {
                this.promiseBasedPlay(audio).catch(error => {
                  console.log("Failed to play sound:", error);
                });
              }
            } catch (e) {
              console.log("Error playing sound:", e);
            }
          }
        }
      } catch (error) {
        console.error("Error processing WebSocket message:", error);
      }
    },

    appearance_user: function () {
      if (this.$store.state.signedIn) {
        if (this.$store.getters.getCompany.company) {
          // FT-066: perform on the held AppearanceChannel subscription object (native API).
          //
          // Backend AppearanceChannel#appearance_user(_data) ignores the payload ENTIRELY:
          // it takes params[:room] from the subscription identifier (the object passed to
          // $cableSubscribe above), never from the frame. The `room` below is therefore
          // redundant — kept only because this was a comment-only fix; it is a company id,
          // not a secret, so it costs nothing to leave.
          //
          // What must NEVER go here is the user object. ActionCable interpolates the raw
          // WebSocket frame into its own error log lines, so anything sent here can end up
          // in Loki verbatim — that is exactly how traccar_password, email, phone and cash
          // balances leaked from clients on stale bundles (see rentalman-api api#577 and
          // memory-bank/ops/runbooks/security-actioncable-frame-log-leak-2026-08-31.md).
          if (this.appearanceSub) {
            this.appearanceSub.perform("appearance_user", {
              room: this.$store.getters.getCompany.company.id,
            });
          }
        } else {
          this.axios
            .get(`/api/v1/company`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.$store.commit("setCompany", { company: response.data });
              // this.$router.push({ path: `/dashboard` }).catch(err => {})
            })
            .catch((error) => {
              this.isLoading = false;
              this.setError(error, this.$t("errors.company_data"));
              console.log(error);
            });
        }
      }
    },
    createdBefore(date) {
      if (date) {
        return moment(date).format("ll");
      }
    },
    loadBranches() {
      if (this.branches && this.branches.length > 0) {
        return;
      }
      this.isLoading = true;
      this.axios
        .get("/api/v1/main_companies", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.branches = response.data.filter(b => !b.archived);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.branch_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
      // this.$router.push({ path: `/dashboard` }).catch((err) => {});
    },
    changeBranch(id) {
      if (this.$store.getters.getCompany.company.id == id) {
        return;
      }
      let self = this;
      this.isLoading = true;
      this.axios
        .post(
          "/api/v1/select_company",
          {
            id: id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // Отписываемся от всех каналов
          this.unsubscribeFromChannels();
          this.$store.commit("setCompany", { company: response.data });
          // FT-076: сбрасываем кэш задач/исполнителей предыдущего филиала
          this.$store.commit("tasks/RESET");
          this.axios
            .get("/me.json", {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.$store.commit("setCurrentUser", response.data);
            })
            .catch((error) => {
              // FT-136. Раньше здесь стоял `function (error)`, поэтому `this` в
              // строгом ESM не определён и первая же строка бросала TypeError —
              // весь блок был мёртв. Приведение к стрелочной функции оживило бы
              // вместе с ним и разлогин на ЛЮБОЙ ошибке /me.json после смены
              // филиала (на 5xx и таймауте вердикт классификатора ложен, поэтому
              // человека выкинуло бы на форму входа без объяснения). Разлогин
              // удалён: сегодняшний исход сохраняется, сообщение становится
              // человеческим.
              this.isLoading = false;
              this.setError(error, this.$t("errors.error"));
            });
          if (this.$router.currentRoute.path == "/dashboard") {
            // Переход на главную страницу и обновление
            setTimeout(() => {
              this.$router.go(this.$router.currentRoute);
            }, 500);
          } else {
            if (!this.isAgent) {
              this.$router.push({ path: `/dashboard` }).catch((err) => { });
            } else {
              this.$router.push({ path: `/search_free` }).catch((err) => { });
            }
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.change_branch"));
        })
        .finally(() => (this.isLoading = false));
    },
    unsubscribeFromChannels() {
      // ✅ BEST PRACTICE: Используем Vuex action для отписки от boot-каналов
      // Вызывается только при logout или смене филиала
      this.$store.dispatch('websocketSubscriptions/unsubscribeAll');
      // FT-066: AppHeader-owned channels не управляются boot-модулем — отписываем held-объекты
      // здесь (AppHeader при logout/смене филиала НЕ разрушается, поэтому mixin beforeDestroy
      // не сработает; нужно явно сбросить, чтобы при новом company они переподписались).
      this.$cableUnsubscribe(this.appearanceSub); this.appearanceSub = null;
      this.$cableUnsubscribe(this.newBookingSub); this.newBookingSub = null;
      this.$cableUnsubscribe(this.teletypeSub); this.teletypeSub = null;
    },
    goToMap() {
      if (this.traccarMapAvailable) {
        let data = new URLSearchParams({
          "email": this.$store.getters.getCurrentUser.email,
          "password": this.$store.getters.getCurrentUser.traccar_password
        })
        // authorization in socket
        let session_url = "https://vos-rentprog.ru/api/session"
        this.axios({
          method: "post",
          url: session_url,
          headers: {
            "Authorization": "Basic " + btoa(`${this.$store.getters.getCurrentUser.email}:${this.$store.getters.getCurrentUser.traccar_password}`),
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: data
        })
          .then(response => {
            if (response.status != 200) {
              return
            } else {
              const url = 'https://vos-rentprog.ru';
              window.open(url, '_blank');
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    checkSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    checkAdminManager() {
      return (
        this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isManager
      );
    },
    checkManager() {
      return this.$store.getters.isManager;
    },
    checkLate() {
      let todos = this.todos.filter((todo) => todo.done != true);
      const late_todos_check = (todo) => moment().isAfter(todo.end_date, "day");
      if (!todos.some(late_todos_check)) {
        return "green";
      } else {
        return "red";
      }
    },
    // FT-183: виден ли пункт шапки — раздел не скрыт для типа техники компании.
    menuRouteVisible(path) {
      return routeVisible(this.rental_object(), path);
    },
    rental_object() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.rental_object) {
        return this.$store.getters.getCompany.company.rental_object;
      } else {
        return 'cars';
      }
    },
    promiseBasedPlay(audioElement) {
      // Проверка, является ли audio элементом
      if (!audioElement || !(audioElement instanceof HTMLAudioElement)) {
        return Promise.reject(new Error('Not an audio element'));
      }

      // Перемотка в начало для повторного воспроизведения
      audioElement.currentTime = 0;

      // Возвращаем промис для обработки ошибок
      return audioElement.play().catch(error => {
        // Проверяем, нужно ли показывать кнопку включения звука
        if (error.name === 'NotAllowedError') {
          console.log('Autoplay prevented. User must interact with the document first.');

          // Можно показать подсказку пользователю
          this.showAudioNotAllowedNotification = true;
        }

        // Пробрасываем ошибку дальше
        throw error;
      });
    },
    menu_object_name() {
      let name = '';
      if (this.rental_object() === 'cars') {
        name = this.$t("rental_objects.cars_menu");
      } else if (this.rental_object() === 'bicycles') {
        name = this.$t("rental_objects.bicycles_menu");
      } else if (this.rental_object() === 'motorcycles') {
        name = this.$t("rental_objects.motorcycles_menu");
      } else if (this.rental_object() === 'boats') {
        name = this.$t("rental_objects.boats_menu");
      } else if (this.rental_object() === 'construction_machinery') {
        name = this.$t("rental_objects.construction_machinery_menu");
      } else if (this.rental_object() === 'equipment') {
        name = this.$t("rental_objects.equipment_menu");
      } else if (this.rental_object() === 'airplanes') {
        name = this.$t("rental_objects.airplanes_menu");
      } else if (this.rental_object() === 'trucks') {
        name = this.$t("rental_objects.trucks_menu");
      } else if (this.rental_object() === 'trailers') {
        name = this.$t("rental_objects.trailers_menu");
      } else if (this.rental_object() === 'caravans') {
        name = this.$t("rental_objects.caravans_menu");
      } else if (this.rental_object() === 'taxies') {
        name = this.$t("rental_objects.taxies_menu");
      } else if (this.rental_object() === 'other') {
        name = this.$t("rental_objects.other_menu");
      }
      return name;
    },
    replaceToProfile() {
      this.$router.push({ name: "Profile" }).catch((err) => { });
    },
    replaceToSalary() {
      this.$router.push({ name: "Salary" }).catch((err) => { });
    },
    replaceToSchedule() {
      this.$router.push({ name: "ScheduleCalendar" }).catch((err) => { });
    },
    replaceToCompanyProfile() {
      this.$router.push({ name: "CompanyProfile" }).catch((err) => { });
    },
    replaceToCompanyCounts() {
      this.$router.push({ name: "CompanyCounts" }).catch((err) => { });
    },
    async checkCrispSiteAvailable() {
      if (!$crisp || typeof $crisp == "undefined" || !$crisp.is) {
        return false;
      }
      return await $crisp.is("website:available");
    },
    signOut() {
      // FT-191 REQ-05: на общем компьютере «Выйти» из любого меню — блокировка, а не выход.
      if (this.$store.getters["deviceLock/deviceMode"]) {
        this.$store.dispatch("deviceLock/lock");
        return;
      }
      if (this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.email && this.isNative) {
        purchaseService.logout().catch(err => {
          console.warn('RevenueCat logout failed:', err);
        });
      }
      let self = this;
      // FT-136: выход завершается локально при любом исходе запроса (см. App.vue).
      // Устройство пушей — до sign_out: после отзыва JWT запрос не авторизовать.
      forgetPushDevice(this)
        .then(() =>
          this.axios(
            markIntentionalLogout({
              url: "users/sign_out",
              baseURL: this.$store.getters.getApiUrl, // FT-018
              method: "delete",
              headers: { Authorization: self.$store.getters.getAuthToken },
            })
          )
        )
        .catch((error) => {
          if (!(error && error.response && error.response.status === 401)) {
            self.setError(error, self.$t("errors.sign_out_unconfirmed"));
            // setError молчит на транзиентных сетевых обрывах (их индицирует баннер) — а
            // здесь молчать нельзя: именно при обрыве отзыв токена точно не состоялся.
            // Прямой $notify гарантирует предупреждение при любом не-401 исходе; на 5xx
            // он перезаписывает общий тост setError — последний вызов в снекбаре побеждает.
            self.$notify(self.$t("errors.attention"), self.$t("errors.sign_out_unconfirmed"), "warning", 6000);
          }
          console.log(error);
        })
        .finally(() => {
          self.isLoading = false;
          // FT-066: clear subscriptions BEFORE unsetCurrentUser, symmetric with changeBranch
          // (idempotent; the auth_token watcher below also covers 401/shared logout paths).
          self.unsubscribeFromChannels();
          self.$store.commit("unsetCurrentUser");
        });
    },
    checkAdmin() {
      return this.$store.getters.isAdmin;
    },
    hideOnScroll() {
      return false;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    reverseDrawer() {
      return this.$store.commit("setDrawer", !this.$store.getters.getDrawer);
    },
    // Метод для сброса счетчика сообщений
    resetTeletypeMessagesCount() {
      this.$store.commit("resetTeletypeMessagesCount");
    },
    // FT-066: hasSubscription removed — it scanned the old wrapper registry for dedup of the
    // former @1117 Teletype subscribe (now a held-ref this.teletypeSub guard). Fully dead.
    enableSound() {
      const audio = document.getElementById('message-audio');
      if (audio) {
        // Пользователь нажал на кнопку, теперь мы можем воспроизвести звук
        audio.play().catch(e => console.log('Still unable to play:', e));
      }
      this.showAudioNotAllowedNotification = false;
    },
    openSearch() {
      this.$refs.pageSearch.openSearch();
    },
    truncateUsername(username) {
      if (username && username.length > 9) {
        return username.slice(0, 9) + '...';
      }
      return username;
    }
  },
  watch: {
    // ... existing watchers

    // FT-066: logout cleanup covering ALL paths (logout button AND 401/shared unsetCurrentUser
    // dispatched from main.js interceptor — AppHeader can't hook main.js directly). On token→null
    // we drop boot-channels (unsubscribeAll) + AppHeader held-refs so a subsequent login in the
    // same SPA session (especially into a DIFFERENT branch) re-subscribes against the current
    // company.id instead of early-returning past stale subscriptions. Idempotent: held-ref guards
    // + the subscriptionsInitialized guard in unsubscribeAll prevent double-unsubscribe.
    // CableReconnect already disconnects the consumer on token→null — we only clear subs/state here.
    "$store.state.auth_token"(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.unsubscribeFromChannels();
      }
    },

    // WS-подписки поднимаем, как только company реально загружена (появился id) — независимо
    // от тайминга гидрации/маунта. Закрывает «Cannot initialize - company not loaded» на гоночных
    // маунтах: сначала срабатывает ветка GET /company (mounted else) → setCompany → этот watcher
    // → init. initializeSubscriptions идемпотентен (subscriptionsInitialized), повторов не будет.
    // См. [feedback_vuex_hydration_race]: не гейтить логику в mounted по невосстановленным данным.
    "$store.getters.getCompany.company.id": function (newId) {
      if (newId) {
        this.$store.dispatch("websocketSubscriptions/initializeSubscriptions", {
          userRole: this.user_role,
        });
        // FT-066: AppHeader-owned channels (idempotent via held refs).
        this.subscribeAppHeaderChannels();
      }
    },

    // Гарантируем загрузку ПОЛНОГО main_company (с id/plan), когда company известна.
    // Начальный state.main_company = { balance:0, payer_state:0, currency } — без id/plan.
    // Signin грузит main_company вложенно и НЕ ждёт навигацию (фетч может не доехать/упасть),
    // на F5 boot-перезагрузки нет → в сторе остаётся обрезок → getMainCompany.id undefined,
    // getMainCompany.plan undefined → CRM-gate (router index.js:745) редиректит на Home и
    // MainCompanyChannel не подписывается. immediate — чтобы поймать восстановленный из persist
    // company.main_company_id уже на boot (watcher ставится ПОСЛЕ синхронной гидрации).
    // Самовосстанавливает и уже испорченный persist. Идемпотентно: фетчим только если id нет.
    "$store.getters.getCompany.company.main_company_id": {
      immediate: true,
      handler(mcId) {
        const mc = this.$store.getters.getMainCompany;
        if (mcId && (!mc || !mc.id)) {
          this.axios
            .get(`/api/v1/main_companies/${mcId}`, {
              headers: { Authorization: this.$store.getters.getAuthToken },
            })
            .then((r) => this.$store.commit("setMainCompany", r.data))
            .catch((e) => console.error("[main_company recovery] failed:", e));
        }
      },
    },

    // Когда main_company реально загрузился (появился id) — до-подписываем MainCompanyChannel.
    // В initializeSubscriptions он мог быть пропущен, т.к. main_company доезжает позже company
    // (recovery-фетч выше асинхронный). ensureMainCompanyChannel идемпотентен.
    "$store.getters.getMainCompany.id": function (newId) {
      if (newId) {
        this.$store.dispatch("websocketSubscriptions/ensureMainCompanyChannel");
      }
    },

    // Сбрасываем счетчик при переходе на страницу чата
    $route(to) {
      if (to.path === '/teletype') {
        this.resetTeletypeMessagesCount();
      }
    }
  },
  components: {
    UserAvatar,
    drawer,
    PageSearch,
    NotificationBell
  },
};
</script>

<style lang="css">
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 10px !important;
}

/* Аватар-меню в хедере: у кнопки-активатора (v-btn icon) остаётся ::before-оверлей
   (hover/focus/active фон) — при клике он рисует тёмный круг/«обводку» вокруг аватара,
   пока открыто меню. ripple уже отключён через :ripple="false"; гасим и оверлей + outline.
   Хук — выделенный класс .header-avatar-btn (НЕ id онбординг-тура registration-step-1). */
.header-avatar-btn::before {
  opacity: 0 !important;
}
.header-avatar-btn:focus,
.header-avatar-btn:hover,
.header-avatar-btn:active {
  outline: none !important;
  box-shadow: none !important;
}

.user-name-container {
  display: block;
  width: 100%;
  max-width: 80px !important;
  /* Строго ограничиваем ширину */
  text-align: center;
  overflow: hidden;
}

.user-name {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-size: 11px !important;
}

/* Для кнопки аватара */
.user-avatar-btn {
  width: 80px !important;
  /* Фиксированная ширина кнопки */
  height: auto !important;
  border-radius: 4px;
  overflow: hidden;
}

.user-avatar-btn::before {
  border-radius: 4px;
}

/* Отключаем эффект подсветки при наведении и активации */
.user-avatar-btn::before,
.user-avatar-btn::after {
  display: none !important;
}

/* Убираем изменение цвета фона при наведении */
.user-avatar-btn:hover,
.user-avatar-btn:focus,
.user-avatar-btn:active {
  background-color: transparent !important;
}

/* Если в Vuetify используется ripple-эффект, его тоже можно отключить */
.user-avatar-btn .v-ripple__container {
  display: none !important;
}
</style>
